import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import { initialize } from "redux-form";
import confirmDialog from "../common/dialog/confirmDialog";
import { buscarSessao } from "../auth/authActions";
import { dataParaIso } from "../utils/dataParaIso";

export function setModoTela(modo, registro = {}) {
    return {
        type: "USUARIO_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}
export function initForm(registro = {}) {
    return [
        initialize("usuarioForm", {
            ...registro,
            data_nascimento: dataParaIso(registro.data_nascimento) || "",
        }),
    ];
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            
            dispatch(setAguardando(true));

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/usuario?id_empresa=${idEmpresa}&id_cliente=${usuarioLogado.id_cliente}`);

            dispatch({
                type: "USUARIO_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function setPermissao(registro) {
    return async (dispatch, getState) => {
        if (!registro.id) {
            setError("Não foi possível definir a permissão");
            return {};
        }
        try {
            dispatch(setAguardando(true));
            await axios.post(`${consts.API_URL}/usuario/permissao`, { ...registro });
            dispatch(buscarSessao());
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function setPermissaoUnidadeConsumidora({ unidades_consumidoras_usuario, id_usuario }) {
    return async (dispatch, getState) => {
        try {
            if (!getState().auth.usuarioLogado) return {};

            dispatch(setAguardando(true));
            await axios.post(`${consts.API_URL}/usuario/permissaoUnidadeConsumidora`, {
                unidades_consumidoras_usuario,
                id_usuario,
            });
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function setAguardando(valor) {
    return {
        type: "USUARIO_SET_AGUARDANDO",
        payload: valor,
    };
}

export function getListaUsuario() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = axios.get(`${consts.API_URL}/usuario/listarSelect?id_empresa=${usuarioLogado.id_empresa}`);
            dispatch({
                type: "USUARIO_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_empresa=${idEmpresa}`);

            dispatch({
                type: "USUARIO_CLIENTE_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getTotalUsuarios(idEmpresa) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = axios.get(`${consts.API_URL}/usuario/totalUsuarios?id_empresa=${idEmpresa}`);
            dispatch({
                type: "TOTAL_USUARIOS",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getLogados({ callback, idEmpresa }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = await axios.get(`${consts.API_URL}/usuario/listarLogados?id_empresa=${idEmpresa}`);
            dispatch({
                type: "LOGADOS_USUARIOS",
                payload: request,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            if (callback) callback();
        }
    };
}

export function salvar(registro) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));
            if (!registro.id) {
                const resp = await axios.post(`${consts.API_URL}/usuario`, { ...registro });
                if (registro.usuario_implantacao) {
                    const permissoesUsuarioImplantacao = {
                        id: resp.data.id,
                        acesso_cadastro_cliente_adicionar: true,
                        acesso_cadastro_cliente_editar: true,
                        acesso_cadastro_cliente_excluir: true,
                        acesso_cadastro_cliente_visualizar: true,
                        acesso_fatura_editar: true,
                        acesso_fatura_editar_fechado: true,
                    };
                    dispatch(setPermissao(permissoesUsuarioImplantacao));
                }
            } else {
                if (!window.confirm("Deseja realmente alterar?")) return {};
                await axios.put(`${consts.API_URL}/usuario`, { ...registro });
            }

            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function alterarPerfil({ registro, callback }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            if (!window.confirm("Deseja realmente alterar?")) return {};
            await axios.put(`${consts.API_URL}/usuario/perfil`, { ...registro });

            setSuccess("Operação Realizada com sucesso.");
            dispatch(buscarSessao());
            if (callback) callback();
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function setEmitirAlertaSonoro() {
    return (dispatch, getState) => {
        const alteracaoConfirmada = getState().auth.usuarioLogado.emitir_alerta_sonoro
            ? window.confirm("Deseja realmente desativar o alerta sonoro?")
            : window.confirm("Deseja realmente ativar o alerta sonoro?");
        if (alteracaoConfirmada)
            axios
                .patch(`${consts.API_URL}/usuario/emitirAlertaSonoro/${getState().auth.usuarioLogado.id}`, {
                    emitir_alerta_sonoro: !getState().auth.usuarioLogado.emitir_alerta_sonoro,
                })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(buscarSessao());
                })
                .catch((e) => {
                    setErroAPI(e);
                });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/usuario?id=${registro.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}
